module.exports = __webpack_public_path__ + "static/data-c0137a86aea586b777fa09486333a683.svg";